<template>
    <div class="wrt-addTable">
        <!------------>
        <!-- 本周表 -->
        <Table :columns="columns1" :data="this.wrtReport.thisweek" border></Table>
        <!-- 辅助添加本周表使用 -->
        <Table :columns="columns2" :data="this.data1" border :show-header='false'></Table>
        <!------------>
        <!-- 下周表 -->
        <Table :columns="columns3" :data="this.wrtReport.nextweek" border></Table>
        <!-- 辅助添加下周表使用 -->
        <Table :columns="columns4" :data="this.data1" border :show-header='false'></Table>
        <!------------>
        <!-- 其他表 -->
        <Table :columns="columns5" :data="this.wrtReport.else" border></Table>
        <!-- 辅助添加其他表使用 -->
        <Table :columns="columns6" :data="this.data1" border :show-header='false'></Table>
    </div>
</template>

<script>
    import ajax from '@/lib/ajax'
    export default {
        data() {
            return {
                month: '', //月,辅助计算周数使用
                date: '', //日,辅助计算周数使用
                thisweek: { //辅助添加本周表的数据
                    problem: '',
                    solution: '',
                    check: false
                },
                nextweek: { //辅助添加下周表的数据
                    todo: '',
                    time: ''
                },
                else: { //辅助添加其他表的数据
                    consort: '',
                    suggest: ''
                },
                columns1: [ //本周表的表格渲染
                    {
                        renderHeader: (h) => {
                            return h('span', {
                                style: {
                                    fontSize: '1.5em'
                                }
                            }, `${this.wrtReport.year}年第${this.wrtReport.week}周工作汇报`)
                        },
                        align: 'center',
                        children: [{
                                renderHeader: (h) => {
                                    return h('div', {
                                        style: {
                                            fontSize: '1.2em'
                                        }
                                    }, [
                                        h('label', '姓名：'),
                                        h('Input', {
                                            props: {
                                                value: this.wrtReport.name
                                            },
                                            on: {
                                                input: (e) => {
                                                    this.wrtReport.name = e
                                                }
                                            },
                                            style: {
                                                width: '450px'
                                            }
                                        })
                                    ])
                                },
                                align: 'center',
                                children: [{
                                        title: '操作',
                                        align: 'center',
                                        width: 150,
                                        render: (h, params) => {
                                            return h('Button', {
                                                props: {
                                                    type: 'warning',
                                                    size: 'small'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.wrtReport.thisweek.splice(
                                                            params.index, 1)
                                                    }
                                                }
                                            }, '删除')
                                        }
                                    },
                                    {
                                        title: '本周工作中发现的问题',
                                        align: 'center',
                                        key: 'problem'
                                    }
                                ]
                            },
                            {
                                renderHeader: (h) => {
                                    return h('div', {
                                        style: {
                                            fontSize: '1.2em',
                                        }
                                    }, [
                                        h('label', '时间段：  '),
                                        h('DatePicker', {
                                            props: {
                                                type: 'daterange',
                                                showWeekNumbers: true,
                                                clearable: false,
                                                value: this.wrtReport.time,
                                                placement: 'bottom-start'
                                            },
                                            on: {
                                                'on-change': this.timeChange
                                            },
                                            style: {
                                                width: '450px'
                                            }
                                        })
                                    ])
                                },
                                align: 'center',
                                children: [{
                                        title: '解决方案',
                                        align: 'center',
                                        key: 'solution'
                                    },
                                    {
                                        title: '是否已解决',
                                        align: 'center',
                                        width: 150,
                                        render: (h, params) => {
                                            return h('span', this.wrtReport.thisweek[params.index]
                                                .check ? '已解决' : '未解决')
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ],
                columns2: [ //辅助添加本周表的表格渲染
                    {
                        title: '操作',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        if(this.thisweek.problem&&this.thisweek.solution){
                                            this.wrtReport.thisweek.push(this.thisweek);
                                            this.thisweek = {
                                                problem: '',
                                                solution: '',
                                                check: false
                                            }
                                        }
                                    }
                                }
                            }, '添加')
                        }
                    }, {
                        title: '本周工作中发现的问题',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: this.thisweek.problem
                                },
                                on: {
                                    input: (e) => {
                                        this.thisweek.problem = e;
                                    }
                                }
                            })
                        }
                    }, {
                        title: '解决方案',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: this.thisweek.solution
                                },
                                on: {
                                    input: (e) => {
                                        this.thisweek.solution = e;
                                    }
                                }
                            })
                        }
                    }, {
                        title: '是否已解决',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: this.thisweek.check
                                },
                                on: {
                                    input: (e) => {
                                        this.thisweek.check = e;
                                    }
                                }
                            }, this.thisweek.check ? '已解决' : '未解决')
                        }
                    }
                ],
                columns3: [ //下周表的表格渲染
                    {
                        title: '操作',
                        width: 150,
                        align: 'center',
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.wrtReport.nextweek.splice(params.index, 1)
                                    }
                                }
                            }, '删除')
                        }
                    }, {
                        title: '下周工作重点',
                        key: 'todo',
                        align: 'center'
                    }, {
                        title: '预计完成时间',
                        width: 150,
                        key: 'time',
                        align: 'center'
                    }
                ],
                columns4: [ //辅助添加下周表的表格渲染
                    {
                        title: '操作',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        if(this.nextweek.todo&&this.nextweek.time){
                                            this.wrtReport.nextweek.push(this.nextweek);
                                            this.nextweek = {
                                                todo: '',
                                                time: ''
                                            }
                                        }
                                    }
                                }
                            }, '添加')
                        }
                    }, {
                        title: '下周工作重点',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: this.nextweek.todo
                                },
                                on: {
                                    input: (e) => {
                                        this.nextweek.todo = e;
                                    }
                                }
                            })
                        }
                    }, {
                        title: '预计解决时间',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('DatePicker', {
                                props: {
                                    value: this.nextweek.time
                                },
                                on: {
                                    'on-change': (time) => {
                                        this.nextweek.time = time;
                                    }
                                }
                            })
                        }
                    }
                ],
                columns5: [ //其他表的表格渲染
                    {
                        title: '操作',
                        width: 150,
                        align: 'center',
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.wrtReport.else.splice(params.index, 1)
                                    }
                                }
                            }, '删除')
                        }
                    }, {
                        title: '工作需要协调的事项',
                        key: 'consort',
                        align: 'center'
                    }, {
                        title: '合理化建议',
                        key: 'suggest',
                        align: 'center'
                    }
                ],
                columns6: [ //辅助其他表的表格渲染
                    {
                        title: '操作',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        if(this.else.consort&&this.else.suggest){
                                            this.wrtReport.else.push(this.else);
                                            this.else = {
                                                consort: '',
                                                suggest: ''
                                            }
                                        }
                                    }
                                }
                            }, '添加')
                        }
                    }, {
                        title: '工作需要协调的事项',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: this.else.consort
                                },
                                on: {
                                    input: (e) => {
                                        this.else.consort = e;
                                    }
                                }
                            })
                        }
                    }, {
                        title: '合理化建议',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: this.else.suggest
                                },
                                on: {
                                    input: (e) => {
                                        this.else.suggest = e;
                                    }
                                }
                            })
                        }
                    }
                ],
                data1: [{}], //辅助添加表格的占位数据，固定为空
                wrtReport: {    //周报数据
                    year: '',
                    week: '',
                    name: '',
                    time: '',
                    thisweek: [],
                    nextweek: [],
                    else: []
                }
            }
        },
        methods: {
            getWeek(year, month, day) { //计算周数
                let date1 = new Date(year, 0, 1);
                let date2 = new Date(year, month, day, 1);
                let dayMS = 24 * 60 * 60 * 1000;
                let firstDay = (7 - date1.getDay()) * dayMS;
                let weekMS = 7 * dayMS;
                date1 = date1.getTime();
                date2 = date2.getTime();
                this.wrtReport.week = Math.ceil((date2 - date1 - firstDay) / weekMS) + 1;
            },
            defaultTime() { //首次进入时默认提供当前日期的周数和时间段
                this.wrtReport.year = new Date().getFullYear();
                this.month = new Date().getMonth();
                this.date = new Date().getDate();
                let day = new Date().getDay();
                let time = [];
                time[0] = `${this.wrtReport.year}-${this.month+1}-${this.date-day}`
                time[1] = `${this.wrtReport.year}-${this.month+1}-${this.date-day+6}`
                this.wrtReport.time = time;
                this.getWeek(this.wrtReport.year, this.month, this.date);
            },
            timeChange(time) { //当用户主动选择日期时重新计算周数
                this.wrtReport.time = time;
                time = time[1].split('-');  //format：YYYY-MM-DD，拿到结束日期来计算周数
                this.wrtReport.year = parseInt(time[0]);
                this.month = time[1] - 1;   //这里的month需要格式化一下
                this.date = time[2];
                this.getWeek(time[0], time[1] - 1, time[2]);
            },
            async commit(){ //提交周报
                let rep = await ajax.post("http://192.168.160.101:8888/wrt/add",this.wrtReport);
                if(rep.data.success){
                    console.log(rep)
                }
            }
        },
        created() {
            this.defaultTime();
        }
    }
</script>

<style lang="less">
    .wrt-addTable {
        .ivu-table:before {
            height: 0
        }
    }
</style>